// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".download-import-template .border[data-v-b1eff80c] {\n  width: 360px;\n  height: 93px;\n  margin-top: 10px;\n  border: 2px solid #888888;\n}\n.download-import-template .el-checkbox__label[data-v-b1eff80c] {\n  padding-left: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
